import axios from '../axios'

export const getStatus = (data) => {
  return axios({
      url: '/list/getStatus',
      method: 'get',
      data
  })
}
/**
 * 如果listType == null ,获取系统中保存到用户上架计划Profile，传值就加载默认配置
 * 高峰期:P，非高峰期：N，时间均分：A，手动：M
*/
export const loadProfile = (listType) => {
  if(listType == null) listType = "";
  return axios({
      url: '/list/loadProfile',
      method: 'get',
      params: {
        listType: listType
      }
  })
}
export const saveProfile = (data) => { 
  return axios({
      url: '/list/saveProfile',
      method: 'post',
      params: {
        refreshAll: data.refreshAll
      },
      data
  })
}
export const updateStatus = (data) => {
  return axios({
      url: '/list/updateStatus',
      method: 'post',
      params: {
        status: data
      }
  })
}
export const findPage = (data) => {
  return axios({
      url: '/list/getItems',
      method: 'post',
      data
  })
}
export const saveItems = (data) => {
  return axios({
      url: '/list/saveItems',
      method: 'post',
      data
  })
}
export const delItems = (data) => {
  return axios({
      url: '/list/delItems',
      method: 'post',
      data
  })
}
export const moveAll = (data) => {
  return axios({
      url: '/list/moveAll',
      method: 'post',
      data
  })
}
export const getErrors = (data) => {
  return axios({
      url: '/list/errors',
      method: 'get',
      data
  })
}
export const oneStart = (data) => {
  return axios({
      url: '/list/one',
      method: 'get',
      data
  })
}
export const getRept = (data) => {
  let weekday  = data.weekday
  let qType = data.qType
  return axios({
      url: '/list/getRept',
      method: 'get',
      params: {
        weekday: weekday,
        qType: qType,
      },
      data
  })
}




// WEBPACK FOOTER //
// ./src/http/modules/listing.js